export const ErrorHandlingProxy = (onError: (e?: unknown) => void) => ({
  get(target: object, prop: keyof typeof target) {
    const value = target[prop] as unknown;
    if (value instanceof Function) {
      return function (...args: unknown[]) {
        const result = value.apply(target, args);
        if (typeof result === 'object' && 'then' in result) {
          return (result as Promise<unknown>).catch(onError);
        } else {
          return result;
        }
      };
    } else {
      return value;
    }
  }
});
